import { render, staticRenderFns } from "./CinemaClassDetail.vue?vue&type=template&id=49b1e600&scoped=true"
import script from "./CinemaClassDetail.vue?vue&type=script&lang=js"
export * from "./CinemaClassDetail.vue?vue&type=script&lang=js"
import style0 from "./CinemaClassDetail.vue?vue&type=style&index=0&id=49b1e600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1e600",
  null
  
)

export default component.exports